var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"padding-bottom":"10px"}},[_c('p',{staticClass:"text-black-50"},[_vm._v("\n    Новый договор\n    "),_c('i',{staticClass:"tim-icons icon-paper",on:{"click":_vm.addNewOne}})]),_c('big-one',{attrs:{"content":_vm.content,"type":_vm.type,"objects":_vm.objects,"new-one":_vm.newOne}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }